import * as React from 'react'
import type {
	AppearanceThemeMode,
	BrandStylePresetKey,
	ResolvedAppearanceThemeMode,
} from '#app/config/theme'

export type PrivateAppearanceContextValue = {
	selectedTheme: AppearanceThemeMode
	effectiveTheme: ResolvedAppearanceThemeMode
	stylePreset: BrandStylePresetKey
}

const PrivateAppearanceContext =
	React.createContext<PrivateAppearanceContextValue | null>(null)

export function PrivateAppearanceProvider({
	value,
	children,
}: {
	value: PrivateAppearanceContextValue
	children: React.ReactNode
}) {
	return (
		<PrivateAppearanceContext.Provider value={value}>
			{children}
		</PrivateAppearanceContext.Provider>
	)
}

export function usePrivateAppearance() {
	return React.useContext(PrivateAppearanceContext)
}

export function useEffectivePrivateTheme(): ResolvedAppearanceThemeMode {
	return usePrivateAppearance()?.effectiveTheme ?? 'light'
}
